import React, { useState, useEffect, useCallback } from 'react';
import TopHeader from "../../Component/Header/TopHeader";
import {
  Button, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText, Typography, Tooltip
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from "react-hook-form";
import { useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import placeholder from '../../../src/assets/images/Profile/profile.jpg';

import { useUpdateChapterProfileMutation, useLazyGetChapterRoleDetailsByIdQuery } from '../../app/services/chapterServices';
import { selectCurrentRoleId, selectUserId, setImageUrl } from '../../app/auth/authSlice';
import { setRoleDetails } from "../../app/features/chapterAdminSlice";
import { Salutation } from '../../constant/constant';
import ErrorIcon from '@mui/icons-material/Error';
import ImageCropModal, { useImageCrop } from '../../Component/ImageCropModal/ImageCropModal';


const ChapterProfile = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const roleId = useSelector(selectCurrentRoleId);
  const adminId = useSelector(selectUserId);

  const [updateChapterProfile] = useUpdateChapterProfileMutation();
  const [getChapterRoleDetails] = useLazyGetChapterRoleDetailsByIdQuery();
  const { register, handleSubmit, setValue, control, formState: { errors, isValid }, watch, reset, clearErrors, trigger } = useForm(
    {
      mode: "onTouched"  // Validates on touch
    }
  );
  const [selectedImage, setSelectedImage] = useState(null);
  const salutationWatch = watch("salutation");
  const [dirtys, setdirtys] = useState(false);
  const { cropModal, openCropModal, handleCropApply, closeCropModal } = useImageCrop();

  // Fetch chapter role details
  const fetchRoleDetails = useCallback(async () => {
    try {
      const res = await getChapterRoleDetails(roleId);

      if (res?.data?.status) {
        const roleDetails = res.data.data.roleDetails;
        setValue('imageUrl', res?.data?.data?.roleDetails?.roleImageUrl)
        Object.entries(res?.data?.data?.roleDetails).forEach(([key, value]) => {
          setValue(key, value)
        })

        // Ensure salutation is correctly mapped (no need to find if already an ID)
        const validSalutation = roleDetails.salutation;
        // Reset the entire form (ensures fresh state)
        reset({
          ...roleDetails,
          salutation: validSalutation,
          imageUrl: res?.data?.data?.imageUrl || "", // Ensure it's not undefined
        });
        setTimeout(() => {
          setValue("imageUrl", res?.data?.data?.roleDetails?.roleImageUrl || "", { shouldValidate: true, shoulddirtys: true });
        }, 0); // 🔥 Ensure reactivity by deferring execution


        // Ensure React Hook Form detects change
        setValue("salutation", validSalutation, { shouldValidate: true, shoulddirtys: true });
      }
    } catch (error) {
      console.error("Error fetching role details:", error);
    }
  }, [roleId, getChapterRoleDetails, reset, setValue]);

  useEffect(() => {
    fetchRoleDetails();
  }, [fetchRoleDetails]);


  // Handle image upload
  // const handleImageChange = (event) => {
  //   const file = event.target.files[0];

  //   if (!file || !file.type.startsWith("image/")) {
  //     toast.error("Invalid file. Please select an image.");
  //     return;
  //   }

  //   if (file.size > 2 * 1024 * 1024) {
  //     toast.error("File size exceeds 2MB.");
  //     return;
  //   }

  //   const reader = new FileReader();

  //   reader.onload = (e) => {
  //     const img = new Image();
  //     img.src = e.target.result;

  //     img.onload = () => {
  //       if (img.width < 140 || img.width > 150 || img.height < 140 || img.height > 150) {
  //         setError("image", { message: "Image dimensions must be between 140x140 and 150x150 pixels." });
  //         setValue("imageUrl", "");
  //         setValue("image", "");
  //         setSelectedImage(null); // Reset the preview if invalid
  //         return;
  //       }
  //       clearErrors("image");
  //       const base64String = e.target.result;
  //       setSelectedImage(base64String);
  //       setValue("imageUrl", base64String);
  //     };
  //   };

  //   reader.readAsDataURL(file);
  // };

  const onCropSave = async (base64) => {
    setSelectedImage(base64);
    setValue("imageUrl", base64);
    clearErrors("image");
    await trigger();
    if (isValid) {
      setdirtys(true);
    }
  };

  const chapterUpdateProfile = async (data) => {
    try {
      // ✅ Directly access form state for up-to-date validation
      if (isValid || dirtys) {
        const base64Regex = /^data:image\/(png|jpeg|jpg|gif);base64,([A-Za-z0-9+/=]+)$/;
        const updateData = {
          id,
          formData: {
            name: data.name,
            email: data.email,
            address: data.address,
            pincode: data.pincode,
            designation: data.designation,
            institution: data.institution,
            role: data.role,
            mobile: data.mobile,
            salutation: data.salutation,
            imageUrl: base64Regex.test(data?.imageUrl)
              ? data.imageUrl
              : data?.imageUrl?.split("/").slice(-2).join("/") || '',
            roleId,
            adminId,
          },
        };

        const res = await updateChapterProfile(updateData);
        if (res?.data?.status) {
          toast.success(res.data.message);
          dispatch(setRoleDetails(res.data.data?.updateAdminData));
          dispatch(setImageUrl({ imageUrl: res?.data?.data?.updateAdminData?.imageUrl }));
        } else {
          toast.error(res?.data?.err?.message || "Failed to update profile");
        }
      } else {
        toast.success('Chapter Updated Successfully');
      }
    } catch (error) {
      console.error("Profile update error:", error);
      toast.error(error?.response?.data?.message || "Something went wrong!");
    }
  };



  return (
    <div>
      <TopHeader />
      <div className='pt-lg-5 pt-3 '>
        <div className='Architects-header d-flex align-items-center justify-content-center'>
          <h2 className='title-font text-center'>Chapter Profile</h2>
        </div>
      </div>

      <Button
        onClick={() => window.history.back()}
        variant="contained"
        className="menus-color mt-4"
        style={{ float: "right", marginRight: "70px" }}
      >
        Back
      </Button>

      <div className='mb-3 mt-5 p-md-5 p-3 overallPadding'>
        <form onSubmit={handleSubmit(chapterUpdateProfile)}>
          {/* Image Upload Section */}
          <div className='row mb-3 '>
            <div className='col-md-12 d-flex justify-content-center position-relative'>
              {/* Tooltip with Error Icon */}
              <Tooltip title="Image dimensions must be between 140x140 and 150x150 pixels. Image must be .jpg, .jpeg, .png, .jfif">
                <span>
                  <ErrorIcon
                    style={{
                      width: "30px",
                      height: '30px',
                      cursor: "pointer",
                      position: 'absolute',
                      top: "75%",
                      right: "49%",
                      color: "black",
                      backgroundColor: '#d3d3d3',
                      padding: "5px",
                      borderRadius: "50%"

                    }}
                  />
                </span>
              </Tooltip>

              {/* Image Preview */}
              <img
                src={selectedImage || watch("imageUrl") + '?t=' + new Date().getTime() || placeholder}
                height="100"
                alt="Profile"
                style={{ objectFit: "scale-down", width: "200px" }}
                key={watch("imageUrl")}
              />

              {/* Hidden File Input */}
              <TextField
                sx={{ mt: 2 }}
                InputLabelProps={{ shrink: true }}
                inputProps={{ accept: "image/jpeg, image/png" }}
                id="imageUrl"
                type="file"
                style={{ display: 'none' }}
                {...register("image", {
                  required: !watch("imageUrl") && "Please Select an Image",
                  validate: (value) => {
                    if (!watch("imageUrl")) {
                      return "Please Select an Image";
                    }
                    return true;
                  },
                  onChange: (e) => openCropModal(e, null, 2),
                })}
              />

              {/* File Upload Button */}
              <label htmlFor="imageUrl" style={{ marginLeft: "10px", marginTop: '20px' }}>
                <Button variant="contained" className="menus-color border-radius-membership-wallpage-button" component="span">
                  Choose File *
                </Button>
              </label>

              {/* Error Message */}
              <FormHelperText className="pt-3 image-error-membership-wall-profile-chapter" error={!!errors?.image}>{errors?.image?.message}</FormHelperText>
            </div>

            <ImageCropModal
              open={cropModal.open}
              imageSrc={cropModal.src}
              onCancel={closeCropModal}
              onCrop={(base64) => handleCropApply(base64, onCropSave)}
              outputWidth={150}
              outputHeight={150}
              isSquareCrop={true}
            />
          </div>

          {/* Profile Details */}
          <div className='row mt-5'>
            <div className='col-md-4'>
              <Controller
                name="role"
                control={control}
                rules={{ required: "Role is required" }}
                render={({ field, fieldState }) => (
                  <FormControl className="w-100" error={!!fieldState.error}>
                    <InputLabel id="role-label">Role *</InputLabel>
                    <Select label="Role *" {...field} value={field.value || ""} onChange={(e) => {
                      field.onChange(e)
                    }
                    }>
                      <MenuItem value="Convenor">Convenor</MenuItem>
                      <MenuItem value="Co-convenor">Co-convenor</MenuItem>
                      <MenuItem value="Executive Member">Executive Member</MenuItem>
                    </Select>
                    <FormHelperText error={fieldState?.error}>{fieldState.error?.message}</FormHelperText>
                  </FormControl>
                )}
              />
              <TextField className='mt-3'
                InputLabelProps={{ shrink: true }}
                helperText={errors?.designation?.message}
                error={!!errors?.designation}
                fullWidth
                id="designation"
                placeholder="Enter  Designation"
                label={
                  <Typography className="text-dark">
                    Designation <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                {...register("designation", { required: "Please enter designation" })}
              />


              <TextField
                className="mt-3"
                label={
                  <Typography className="text-dark">
                    Pincode
                  </Typography>
                }
                InputLabelProps={{ shrink: true }}
                placeholder="Enter Pincode"

                {...register("pincode", {
                  pattern: {
                    value: /^[0-9]{6}$/, // Adjust the regex to your desired format
                    message: "Please enter a valid 6-digit Pincode"
                  }
                })}
                value={watch("pincode") || ""}
                onChange={(e) => setValue("pincode", e.target.value, { shouldValidate: true })}
                error={!!errors.pincode}
                helperText={errors.pincode?.message}
                fullWidth
              />
            </div>


            <div className='col-md-4'>
              <Controller
                name="salutation"
                control={control}
                rules={{ required: "Salutation is required" }}
                render={({ field, fieldState }) => (
                  <FormControl className="w-100" error={!!fieldState.error}>
                    <InputLabel id="salutation-label">Salutation *</InputLabel>
                    <Select
                      label="Salutation *"
                      {...field}
                      value={salutationWatch ?? ""} // 🔥 Ensures controlled input
                      onChange={(e) => {
                        field.onChange(e.target.value);
                      }}
                    >
                      {Salutation.map((data) => (
                        <MenuItem key={data.id} value={data.id}>
                          {data.Name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{fieldState?.error?.message}</FormHelperText>
                  </FormControl>
                )}
              />
              {/* <TextField
                className="mt-3"
                label="Institution *"
                {...register("institution", { required: "Please Enter Institution" })}
                error={!!errors.institution}
                helperText={errors.institution?.message}
                fullWidth
                value={watch("institution") || ""}
                onChange={(e) => {
                  setValue("institution", e.target.value);
                  trigger("institution"); // Revalidate on change
                }}
              /> */}
              <TextField
                className='mt-3'
                InputLabelProps={{ shrink: true }}
                helperText={errors?.institution?.message}
                error={!!errors?.institution}
                fullWidth
                id="designation"
                placeholder="Enter Institution"
                label={
                  <Typography className="text-dark">
                    Name of the institution <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                {...register("institution", { required: "Please enter institution" })}
              />

              <TextField className='mt-3'
                style={{ width: "100%", }}
                InputLabelProps={{ shrink: true }}
                id="designation"
                label={
                  <Typography className="text-dark">
                    Email ID <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                {...register("email", {
                  required: "Please Enter a email",
                  pattern: {
                    value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                    message: "Please Enter a valid Email",
                  },
                })}
                error={!!errors?.email}
                helperText={errors?.email?.message} />


            </div>
            <div className='col-md-4'>
              <TextField
                InputLabelProps={{ shrink: true }}
                helperText={errors?.name?.message}
                error={!!errors?.name}
                fullWidth
                id="designation"
                placeholder="Enter Name"
                label={
                  <Typography className="text-dark">
                    Name <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                {...register("name", { required: "Please enter name" })}
              />
              <TextField className='mt-3'
                InputLabelProps={{ shrink: true }}
                label={
                  <Typography className="text-dark">
                    Complete Address for Communication <span style={{ color: "red" }}></span>
                  </Typography>
                }
                variant="outlined"
                placeholder="Complete Address for Communication  " {...register("address")} value={watch("address") || ""} onChange={(e) => setValue("address", e.target.value)} fullWidth />
              <TextField
                className="mt-3"
                InputLabelProps={{ shrink: true }}
                placeholder="Enter Mobile Number"
                label={
                  <Typography className="text-dark">
                    Mobile
                  </Typography>
                }
                {...register("mobile", {
                  pattern: {
                    value: /^[0-9]{10}$/, // Adjust the regex to your desired format
                    message: "Please enter a valid 10-digit phone number"
                  }
                })}
                onChange={(e) => setValue("mobile", e.target.value, { shouldValidate: true })}
                value={watch("mobile") || ""}
                error={!!errors.mobile}
                helperText={errors.mobile?.message}
                fullWidth
              />

            </div>

            {/* <div className='col-md-4'>
            
            </div> */}
          </div>

          {/* Submit Button */}
          <div className="d-flex justify-content-center mt-4">
            <Button variant="contained" className="menus-color" type="submit">Update</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChapterProfile;
